var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
    id: "defs196",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath206",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path204",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g198",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g200",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g202",
    clipPath: "url(#clipPath206)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g208",
    transform: "translate(324.9316,350.6797)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-38.07 -30.861,-68.932 -68.932,-68.932 -38.07,0 -68.931,30.862 -68.931,68.932 0,38.07 30.861,68.932 68.931,68.932 C -30.861,68.932 0,38.07 0,0 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path210",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g212",
    transform: "translate(371.8301,440.165)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -27.55,35.6 -70.81,56.87 -115.83,56.87 -45.02,0 -88.28,-21.27 -115.83,-56.87 -31.07,-40.16 -36.63,-88.55 -20.3,-135.84 15.7,-45.46 49.04,-83.37 76.3,-122.44 19.5,-27.95 39,-55.9 58.5,-83.86 0.44,-0.63 0.89,-1.27 1.33,-1.9 0.44,0.63 0.89,1.27 1.33,1.9 19.5,27.96 39,55.91 58.5,83.86 27.26,39.07 60.6,76.98 76.3,122.44 C 36.63,-88.55 31.07,-40.16 0,0 Z",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path214",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g216",
    transform: "translate(164.25,126.8052)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -42.65,-26.94 134.4,-84.9 134.4,84.9 L 183.5,0",
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path218",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.106b610a15652abc3d3426d441c4e298.svg";
export { ForwardRef as ReactComponent };